import { fetch_with_auth, only_when_authorised } from '@phi/frontend/api';
import { PhiFile } from '@phi/jcore';

export const download_step_file = only_when_authorised((title: string, file: PhiFile): Promise<ArrayBuffer | Error> =>
    fetch_with_auth(new Request('/api/step', {
        method: 'POST',
        body: JSON.stringify({ title, file }),
        headers: { 'Content-Type': 'application/json' },
    })).then(async (x) => x.ok ? await x.arrayBuffer() : new Error(`${x.status} ${x.statusText}`)));
